import styled from "styled-components";

export const Section = styled.section`
    background: #fff;
    border-radius: 4px;
    padding: 20px;
`;
